module.exports = __webpack_public_path__ + "img/logo.0efac033.png";